<template>
  <div class="cs-selectCourse-dialog-container">
    <el-tabs
      v-model="activeGroup"
      type="border-card"
      v-loading="isLoading"
    >
      <el-tab-pane name="universityCourse">
        <span slot="label"> {{getCourseTypeText()}} </span>
        <el-row class="grid-content">
          <el-col>
            <selectCourse v-if="courseType == 1"
              :isStudyAbroad="isStudyAbroad"
              :courseType="1"
              :dataIn="universityCourseData"
            ></selectCourse>
            <selectCourse v-if="courseType == 2"
              :courseType="2"
              :dataIn="englishCourseData"
            ></selectCourse>
             <selectCourse v-if="courseType == 3"
              :courseType="3"
              :dataIn="trainingCourseData"
            ></selectCourse>
            <selectCourse v-if="courseType == 4"
              :courseType="4"
              :dataIn="newStudentGuideCourseData"
            ></selectCourse>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <div class="cs-selectCourse-dialog-buttonContainer">
      <el-button
        type="primary"
        @click="onSaveCourse"
      >确认({{selectedCourseCount}})</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-selectCourse-dialog-container {
  padding: 10px 40px 10px 40px;

  .cs-selectCourse-dialog-buttonContainer {
    margin-top: 20px;
    text-align: center;
  }
}
</style>

<script>
import { getCourseTypeText } from "../../../config/mUtils";
import {
  getUniversityGroups,
  getCampusList,
} from "../../../service/common.service";
import { getTrainingCategories } from "../../../service/globalPriceSetting.service";

import selectCourse from "./selectCourse";
export default {
  props: {
    isStudyAbroad: Boolean,
    courseType: Number,
    dataIn: {
      studyAbroadData: {
        workflowServiceItemId: Number,
        endDate: String,
        serviceItemName: String,
        quantityTotal: Number,
        quantityAvailable: Number
      },
      universityCourseData: {
        universityGroupNumber: Number,
        universityGroupText: String,
        termId: Number,
        selectedCourseIdList: Array
      },
      trainingCourseData: {
        termId: Number,
        categoryId: Number,
        campusId: Number,
        selectedCourseIdList: Array
      },
      englishCourseData:{
        categoryId: Number,
        campusId: Number,
        selectedCourseIdList: Array
      },
      newStudentGuideCourseData:{
        categoryId: Number,
        campusId: Number,
        selectedCourseIdList: Array
      }
    }
  },
  data() {
    return {
      activeGroup: "universityCourse",
      universityGroups: [],
      //termList: [],
      trainingCategoryList: [],
      englishCategoryList: [],
      newStudentGuideCategoryList: [],
      //trainingTermList: [],
      campusList: [],
      isLoading: true,
      universityCourseData: {},
      trainingCourseData: {},
      englishCourseData:{},
      newStudentGuideCourseData:{},
      courseData:{},
      isCategoryLoaded: false
    };
  },
  components: {
    selectCourse
  },
  created() {
    getUniversityGroups().then(result => {
      if (!!result && result.success) {
        this.universityGroups = result.data;
        this.init();
      }
    });

    getCampusList().then(result => {
      if (!!result && result.success) {
        this.campusList = result.data;
        this.init();
      }
    });

    getTrainingCategories(0).then(result => {
      if (!!result && result.success) {
        this.englishCategoryList = result.data.filter(i => i.CourseType == 2);
        this.trainingCategoryList = result.data.filter(i => i.CourseType == 3);
        this.newStudentGuideCategoryList = result.data.filter(i => i.CourseType == 4);
        this.isCategoryLoaded = true;
        this.init();
      }
    });
  },
  methods: {
    getCourseTypeText(){
      if (this.isStudyAbroad){
        return "真留计划";
      }else{
        return getCourseTypeText(this.courseType);
      }   
    },
    init() {
      if (
        !!this.universityGroups &&
        this.universityGroups.length > 0 &&
        this.isCategoryLoaded &&
        !!this.campusList &&
        this.campusList.length > 0
      ) {
        this.isLoading = false;
        this.initUniversityCourseData();
        this.initTrainingCourseData();
        this.initEnglishCourseData();
        this.initNewStudentGuideCourseData();
      }
    },
    initUniversityCourseData() {
      let modelData = {};
      if (
        !!this.dataIn.universityCourseData &&
        Object.keys(this.dataIn.universityCourseData).length > 0
      ) {
        modelData = {
          universityGroupNumber: this.dataIn.universityCourseData
            .universityGroupNumber,
          universityGroupText: this.dataIn.universityCourseData
            .universityGroupText,
          termId: this.dataIn.universityCourseData.termId,
          selectedCourseIdList: this.dataIn.universityCourseData
            .selectedCourseIdList,
          selectedCourseList: []
        };
      } else {
        modelData = {
          universityGroupNumber: this.universityGroups[0].GroupNumber,
          termId: 0,
          selectedCourseIdList: [],
          selectedCourseList: []
        };
      }
      this.universityCourseData = {
        isStudyAbroad: this.isStudyAbroad,
        studyAbroadData: this.dataIn.studyAbroadData,
        universityGroups: this.universityGroups,
        modelData: modelData
      };
    },
    initTrainingCourseData() {
      let modelData = {};
      if (
        !!this.dataIn.trainingCourseData &&
        Object.keys(this.dataIn.trainingCourseData).length > 0
      ) {
        let categoryId = this.dataIn.trainingCourseData.categoryId;
        if (!categoryId || this.trainingCategoryList.findIndex(i=> i.Id == categoryId) <0) {
          categoryId = this.trainingCategoryList[0].Id;
        }
        
        let campusId = this.dataIn.trainingCourseData.campusId;
        if (!campusId) {
          campusId = this.campusList[0].Id;
        }
        modelData = {
          termId: this.dataIn.trainingCourseData.termId,
          categoryId: categoryId,
          campusId: campusId,
          selectedCourseIdList: this.dataIn.trainingCourseData
            .selectedCourseIdList,
          selectedCourseList: []
        };
      } else {
        modelData = {
          universityGroupNumber: this.universityGroups[0].GroupNumber,
          termId: 0,
          categoryId: this.trainingCategoryList[0].Id,
          campusId: "",
          selectedCourseIdList: [],
          selectedCourseList: []
        };
      }
      this.trainingCourseData = {
        campusList: this.campusList,
        categoryList: this.trainingCategoryList,
        modelData: modelData
      };
    },
    initEnglishCourseData() {
      let modelData = {};
      let categoryId = 0;
      if (this.englishCategoryList.length > 0)
        categoryId = this.englishCategoryList[0].Id;
      
      if (
        !!this.dataIn.englishCourseData &&
        Object.keys(this.dataIn.englishCourseData).length > 0
      ) {
        let dataCategoryId = this.dataIn.englishCourseData.categoryId;
        if (!!dataCategoryId && this.englishCategoryList.some(i=> i.Id == dataCategoryId))
          categoryId = dataCategoryId;

        let campusId = this.dataIn.englishCourseData.campusId;
        if (!campusId) {
          campusId = this.campusList[0].Id;
        }
        modelData = {
          categoryId: categoryId,
          campusId: campusId,
          selectedCourseIdList: this.dataIn.englishCourseData
            .selectedCourseIdList,
          selectedCourseList: []
        };
      } else {
        modelData = {
          universityGroupNumber: this.universityGroups[0].GroupNumber,
          termId: 0,
          categoryId: categoryId,
          campusId: "",
          selectedCourseIdList: [],
          selectedCourseList: []
        };
      }
      this.englishCourseData = {
        campusList: this.campusList,
        categoryList: this.englishCategoryList,
        modelData: modelData
      };
     
    },
    initNewStudentGuideCourseData(){
      let modelData = {};
      let categoryId = 0;
      if (this.newStudentGuideCategoryList.length > 0)
        categoryId = this.newStudentGuideCategoryList[0].Id;

      if (
        !!this.dataIn.newStudentGuideCourseData &&
        Object.keys(this.dataIn.newStudentGuideCourseData).length > 0
      ) {
        let dataCategoryId = this.dataIn.newStudentGuideCourseData.categoryId;
        if (!!dataCategoryId && this.englishCategoryList.some(i=> i.Id == dataCategoryId))
          categoryId = dataCategoryId;

        // let campusId = this.dataIn.newStudentGuideCourseData.campusId;
        // if (!campusId) {
        //   campusId = this.campusList[0].Id;
        // }
        //设置默认校区为 速成线上
        let campusId = 10;
        modelData = {
          categoryId: categoryId,
          campusId: campusId,
          selectedCourseIdList: this.dataIn.newStudentGuideCourseData
            .selectedCourseIdList,
          selectedCourseList: []
        };
      } else {
        modelData = {
          universityGroupNumber: this.universityGroups[0].GroupNumber,
          termId: 0,
          categoryId: this.newStudentGuideCategoryList[0].Id,
          campusId: "",
          selectedCourseIdList: [],
          selectedCourseList: []
        };
      }
      this.newStudentGuideCourseData = {
        campusList: this.campusList,
        categoryList: this.newStudentGuideCategoryList,
        modelData: modelData
      };
    },
    getUniversityCourseData() {
      let data = {
        courseType: 1,
        universityGroupNumber: this.universityCourseData.modelData
          .universityGroupNumber,
        universityGroupText: this.getUniversityGroupText(
          this.universityCourseData.modelData.universityGroupNumber
        ),
        termId: this.universityCourseData.modelData.termId,
        termText:  this.universityCourseData.modelData.termText,
        selectedCourseList: this.universityCourseData.modelData
          .selectedCourseList
      };
      return data;
    },
    getTrainingCourseData() {
      let data = {
        courseType: 3,
        termId: this.trainingCourseData.modelData.termId,
        termText:  this.trainingCourseData.modelData.termText,
        categoryId: this.trainingCourseData.modelData.categoryId,
        categoryText: this.getTrainingCategoryText(
          this.trainingCourseData.modelData.categoryId
        ),
        campusId: this.trainingCourseData.modelData.campusId,
        campusText: this.getCampusText(
          this.trainingCourseData.modelData.campusId
        ),
        selectedCourseList: this.trainingCourseData.modelData.selectedCourseList
      };
      return data;
    },
    getEnglishCourseData() {
      let data = {
        courseType: 2,
        termId: this.englishCourseData.modelData.termId,
        termText:  this.englishCourseData.modelData.termText,
        categoryId: this.englishCourseData.modelData.categoryId,
        categoryText: this.getEnglishCategoryText(
          this.englishCourseData.modelData.categoryId
        ),
        campusId: this.englishCourseData.modelData.campusId,
        campusText: this.getCampusText(
          this.englishCourseData.modelData.campusId
        ),
        selectedCourseList: this.englishCourseData.modelData.selectedCourseList
      };
      return data;
    },
    getNewStudentGuideCourseData() {
      let data = {
        courseType: 4,
        termId: this.newStudentGuideCourseData.modelData.termId,
        termText:  this.newStudentGuideCourseData.modelData.termText,
        categoryId: this.newStudentGuideCourseData.modelData.categoryId,
        categoryText: this.getNewStudentGuideCategoryText(
          this.newStudentGuideCourseData.modelData.categoryId
        ),
        campusId: this.newStudentGuideCourseData.modelData.campusId,
        campusText: this.getCampusText(
          this.newStudentGuideCourseData.modelData.campusId
        ),
        selectedCourseList: this.newStudentGuideCourseData.modelData.selectedCourseList
      };
      return data;
    },
    onSaveCourse() {
      let universityCourseData = this.getUniversityCourseData();
      let trainingCourseData = this.getTrainingCourseData();
      let englishCourseData = this.getEnglishCourseData();
      let newStudentGuideCourseData = this.getNewStudentGuideCourseData();

      this.$emit("saveSuccess", {
        studyAbroadData: this.dataIn.studyAbroadData,
        universityCourseData: universityCourseData,
        trainingCourseData: trainingCourseData,
        englishCourseData: englishCourseData,
        newStudentGuideCourseData: newStudentGuideCourseData
      });
    },
    getUniversityGroupText(groupNumber) {
      let result = this.universityGroups.filter(
        i => i.GroupNumber == groupNumber
      );
      if (result.length > 0) {
        return result[0].NameValue;
      }
      return "";
    },
    getTrainingCategoryText(id) {
      let result = this.trainingCategoryList.filter(i => i.Id == id);
      if (result.length > 0) {
        return result[0].Name;
      }
      return "";
    },
    getEnglishCategoryText(id) {
      let result = this.englishCategoryList.filter(i => i.Id == id);
      if (result.length > 0) {
        return result[0].Name;
      }
      return "";
    },
    getNewStudentGuideCategoryText(id) {
      let result = this.newStudentGuideCategoryList.find(i => i.Id == id);
      if (result) {
        return result.Name;
      }
      return "";
    },
    getCampusText(id) {
      let result = this.campusList.filter(i => i.Id == id);
      if (result.length > 0) {
        return result[0].Name;
      }
      return "";
    }
  },
  computed: {
    selectedCourseCount: function() {
      let count = 0;
      if (this.courseType == 1){      
        if (
          !!this.universityCourseData &&
          !!this.universityCourseData.modelData &&
          !!this.universityCourseData.modelData.selectedCourseIdList
        ) {
          count = this.universityCourseData.modelData.selectedCourseIdList.length;
        }
      } else if (this.courseType == 2){
        if (
          !!this.englishCourseData &&
          !!this.englishCourseData.modelData &&
          !!this.englishCourseData.modelData.selectedCourseIdList
        ) {
          count = this.englishCourseData.modelData.selectedCourseIdList.length;
        }
      } else if (this.courseType == 4){
        if (
          !!this.newStudentGuideCourseData &&
          !!this.newStudentGuideCourseData.modelData &&
          !!this.newStudentGuideCourseData.modelData.selectedCourseIdList
        ) {
          count = this.newStudentGuideCourseData.modelData.selectedCourseIdList.length;
        }
      } else{
        if (
          !!this.trainingCourseData &&
          !!this.trainingCourseData.modelData &&
          !!this.trainingCourseData.modelData.selectedCourseIdList
        ) {
          count = this.trainingCourseData.modelData.selectedCourseIdList.length;
        }
      }

      return count;
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/selectCourseDialog.vue